import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { CircleAlert, MessageSquareWarning, MapPin } from "lucide-react";
import RecentActivity from "./RecentActivity";
import {
  dashboard_overview,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError } from "../CommonJquery/CommonJquery";
import Loader from "./Loader.js";

const Overview = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const navigate = useNavigate();

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(dashboard_overview, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          console.log(Response.data.data);
          setDashboardData(Response.data.data); // ✅ set API data here
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  // agar data load ho gaya hai to stats set karo
  const stats = [
    {
      title: "Active SOS Alerts",
      value: dashboardData ? dashboardData.active_sos_alerts : 0,
      stat_name: `High Priority`,
      priority: "high-priority",
      valueClass: "high",
      action: () => navigate("/emergencies"),
      icon: <CircleAlert size={30} />,
    },
    {
      title: "Lost & Found Reports",
      value: dashboardData ? dashboardData.lost_and_found_reports : 0,
      stat_name: `Active Reports`,
      priority: "medium-priority",
      valueClass: "medium",
      action: () => navigate("/lost-found"),
      icon: <MessageSquareWarning />,
    },
    {
      title: "Open Locations",
      value: dashboardData ? dashboardData.open_locations : 0,
      stat_name: `Open Locations`,
      priority: "low-priority",
      valueClass: "low",
      action: () => navigate("/view-updates"),
      icon: <MapPin />,
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="overview">
          <h2 className="page-title">Dashboard Overview</h2>
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`stat-card ${stat.priority}`}
                onClick={stat.action}
              >
                <div className="stat-card-inner">
                  <div>
                    <p className={`stat-value ${stat.valueClass}`}>
                      {isLoading ? "..." : stat.value}
                    </p>
                    <p className={`stat-value statPrio ${stat.valueClass}`}>
                      {stat.title}
                    </p>
                  </div>
                  <div className={`stat-icons ${stat.priority}`}>
                    {stat.icon}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ✅ Recent Activity Section */}
          {dashboardData && (
            <RecentActivity
              systemStatus={dashboardData ? dashboardData.points_status : {}}
              recentData={dashboardData ? dashboardData.recent_activity : []}
            />
          )}
        </div>
      </Layout>
    </>
  );
};

export default Overview;
